import api from "./../../api/api";

export const frontendBootApi = () => api.get("term/frontend-boot");
